<template>
  <b-modal v-model="showModal" hide-header hide-footer centered>
    <p class="font-weight-bold f-size-20 text-header">สร้างใหม่/แก้ไข</p>
    <b-form>
      <div class="mb-2" :class="{ errorClass: v.form.dayId.$error }">
        <div>
          <span class="text-title">วัน</span>
          <span class="text-danger">*</span>
        </div>
        <b-form-select
          name="name"
          :value="form.dayId"
          :options="dateLists"
          valueField="id"
          textField="name"
          class="dropdown-setting-date"
          @change="onDateChange"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >เลือกวัน</b-form-select-option
            >
          </template>
        </b-form-select>
        <div v-if="v.form.dayId && v.form.dayId.$error">
          <span class="text-danger" v-if="v.form.dayId.required == false">
            กรุณาเลือกวัน
          </span>
        </div>
      </div>
      <div class="mb-2">
        <div class="d-flex justify-content-between flex-column flex-sm-row">
          <div
            class="mb-2 mb-sm-0"
            :class="{ errorClass: v.form.startTime.$error }"
          >
            <div>
              <span class="text-title">เวลาเปิดทำการ</span>
              <span class="text-danger">*</span>
            </div>
            <datetime
              class="date-picker-input"
              type="time"
              format="HH:mm"
              v-model="form.startTime"
              placeholder="HH:MM"
            />
            <div v-if="v.form.startTime && v.form.startTime.$error">
              <span
                class="text-danger"
                v-if="v.form.startTime.required == false"
              >
                กรุณาเลือกเวลาเปิด
              </span>
            </div>
          </div>
          <div :class="{ errorClass: v.form.startTime.$error }">
            <div>
              <span class="text-title">เวลาปิดทำการ</span>
              <span class="text-danger">*</span>
            </div>
            <datetime
              class="date-picker-input"
              type="time"
              format="HH:mm"
              v-model="form.endTime"
              placeholder="HH:MM"
            />
            <div v-if="v.form.endTime && v.form.endTime.$error">
              <span class="text-danger" v-if="v.form.endTime.required == false">
                กรุณาเลือกเวลาปิด
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <div>
          <span class="text-title">สถานะ</span>
          <span class="text-danger">*</span>
        </div>
        <toggle-button
          class="mt-1 mr-2"
          v-model="form.active"
          :color="{
            checked: '#27BDA7',
            unchecked: '#B0B0B0',
          }"
        />
        <span v-if="form.active" class="ml-2 f-size-18 text-header">
          เปิดการใช้งาน
        </span>
        <span v-else class="ml-2 f-size-18 text-header">ปิดการใช้งาน</span>
        <div v-if="v.form.active && v.form.active.$error">
          <span class="text-danger" v-if="v.form.active.required == false">
            กรุณาเลือกสถานะ
          </span>
        </div>
      </div>
    </b-form>
    <div class="d-flex justify-content-between">
      <button class="cancel-button" @click="onCloseModal">ยกเลิก</button>
      <button class="save-button" @click="onSubmit()">บันทึก</button>
    </div>
  </b-modal>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
export default {
  name: "ModalCreateOrEditTime",
  components: {
    InputSelect,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    dateLists: {
      require: true,
      type: Array,
    },
    onSubmit: {
      require: true,
      type: Function,
    },
    v:{
      require: true,
      type: Object
    }
  },
  data: function() {
    return {
      showModal: false,
    };
  },
  methods: {
    onCloseModal() {
      this.showModal = false;
    },
    onDateChange(value) {
      const getDate = this.dateLists.find(date => date.id === value);
      this.form.name = getDate.name
      this.form.dayId = getDate.id
    }
  },
};
</script>

<style lang="scss" scoped>
.f-size-20 {
  font-size: 20px;
}

.f-size-18 {
  font-size: 18px;
}

.cancel-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #ffffff;
  color: #8f20c6 !important;
  border-radius: 4px;
  border: 1px solid #8f20c6;
  min-width: 30%;
}

.save-button {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  font-size: 14px;
  padding: 0.375rem 0.75rem;
  background-color: #8f20c6;
  color: #ffffff !important;
  border-radius: 4px;
  border: none;
  min-width: 30%;
}

.text-header {
  color: #242424;
}

.text-title {
  color: #575757;
}

.errorClass > .dropdown-setting-date {
  border-color: red !important;
}
</style>
